import { render, staticRenderFns } from "./UploadTbkFiles.vue?vue&type=template&id=70ff3ef4&scoped=true&lang=pug"
import script from "./UploadTbkFiles.vue?vue&type=script&lang=js"
export * from "./UploadTbkFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadTbkFiles.vue?vue&type=style&index=0&id=70ff3ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff3ef4",
  null
  
)

export default component.exports